import PaddingContainer from './PaddingContainer';

export default PaddingContainer;
